module.exports = __webpack_public_path__ + "img/icon_view_2.bd440eaf.svg";